import React from 'react';

import './ChevronCircleIcon.scss';

interface IIconProps {
  direction: 'up' | 'right' | 'down' | 'left';
}

const ChevronCircleIcon = ({ direction }: IIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      fillRule="evenodd"
      id="ki-chevron-left-circle"
      className={`icon-chevron icon-chevron--${direction}`}
    >
      <path
        fill="#fff"
        d="M19.71 22.57L13.14 16l6.57-6.57L18.3 8l-8 8 8 8z"
      ></path>
      <path
        fill="#fff"
        d="M16 4A12.01 12.01 0 1 1 4 16C4 9.38 9.38 4 16 4m0-2a14 14 0 1 0 0 28 14 14 0 0 0 0-28z"
      ></path>
    </svg>
  );
};

export default ChevronCircleIcon;
